export const lsrDivisionsConstants = {
    lsr1_short: "LSR1",
    lsr2_short: "LSR2",
    lsr3_short: "LSR3",
    lsrTs_short: "LSRTS",

    lsr1: "Verðbréfaleið",
    lsr2: "Leið 2 (Hætt)",
    lsr3: "Innlánaleið",
    lsrTs: "Tilgreind séreign (Hætt)",

    lsrB: "B-Deild",
    lsrA: "A-Deild",

    lsrI: "Leið I",
    lsrII: "Leið II",
    lsrIII: "Leið III",
} as const;

export type LsrDivisionKey = keyof typeof lsrDivisionsConstants;
export type LsrDivisionValue = typeof lsrDivisionsConstants[LsrDivisionKey];